import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";
import { ExaminerRepositoryService } from "../../examiner/services/examiner-repository.service";

@DwCustomContextDefinition({
    keyName: 'checkride-outcome-context',
    display: 'Checkride Outcome Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.CheckRideRequest,
})
@Injectable()
export class CheckrideOutcomeContextService extends DwCustomContextBase {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        private examinerRepositoryService: ExaminerRepositoryService
    ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext, contextData) => {
            const outcomeId = this.getOutcomeId(resolvedContext);

            if (!outcomeId) {
                return null;
            }

            return this.examinerRepositoryService.getCheckrideOutcome(outcomeId);
        };

        contextDef.item = AppMetaDataItemNames.CheckRideOutcome;
        contextDef.getCustomContextKey = (resolvedContext) => {
            return this.getOutcomeId(resolvedContext);
        };

        contextDef.useItemMetaData = true;
    }

    getOutcomeId(resolvedContext:any) {
        const checkrideRequest: CheckRideRequestEntity = resolvedContext?.data;  
        return checkrideRequest?.CheckRideResult?.CheckRideOutcomeId;
    }

} 